<style lang="scss" scoped>
.slide-7 {
  background-image: url("../../../assets/module4/slide7/bg-01.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 184px);
  padding-top: 184px;
  padding-left: 156px;
}
video {
  outline: none !important;
  position: absolute;
  top: 133px;
  right: 79px;
  z-index: 9;
  width: 817px;
  height: 457px;
  border-radius: 23px;
}
.play {
  transition: all 0.2s ease-out;
  position: absolute;
  width: 400px;
  display: block;
  right: 288px;
  top: 650px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
p {
  color: white;
  line-height: 40px;
}
.top {
  width: 651px;
  display: flex;
  flex-direction: column;
  p {
    text-align: justify;
  }
}
h1 {
  font-size: 58px;
  line-height: 70px;
  text-align: center;
  display: block;
  margin-left: auto;
  transform: translate(43px, -28px);
}
.num {
  font-size: 188px;
  line-height: 226px;
  font-family: "Kookycat-FASTcaps";
  font-weight: 100;
  color: #e30613;
  text-align: right;
  margin-top: -24px;
  margin-right: -80px;
}
.last {
  width: 400px;
  text-align: left;
  margin-left: auto;
  margin-right: -200px;
}
</style>

<template>
  <div class="slide-7">
    <video
      v-if="showVideo"
      :src="videoURL"
      controls
      autoplay
      ref="video"
    ></video>
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module4/slide7/video-01.png"
        class="chars"
        v-show="slideIndex == 6"
      />
    </transition>
    <a href class="play" @click.prevent="playVideo(videoID)">
      <transition name="scale" appear>
        <img
          class="delay-1"
          v-show="slideIndex == 6"
          src="@/assets/module2/slide5/play_button.svg"
        />
      </transition>
    </a>
    <transition name="fadeLeft" appear>
      <div class="top" v-if="slideIndex == 6">
        <p>
          My superpower is my beautiful voice and when my two lips suddenly
          can’t form speech you should immediately suspect stroke and
        </p>
        <h1>call the<br />Magic Number</h1>
        <div class="num">106</div>
        <p class="last">
          Let’s take a look at what it looks like when the Evil Clot strikes.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_4_video_2?.hd_large?.url ||
        "https://player.vimeo.com/external/372856606.hd.mp4?s=f035b9763d1589f5b33d14540caab3ca815a54dd&profile_id=174",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_4_video_2?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
